module.exports = __webpack_public_path__ + "static/media/lu_casino200Banner.24d98b12.jpg";